namespace Serenity.UI {
    export class ValidationMark extends React.Component {

        render() {
            return (<div className="vx"></div>);
        }

        shouldComponentUpdate() {
            return false;
        }
    }
}